import { gql } from '@apollo/client';

const GET_MOVE_LICENSE_TO_ORG_DATA = gql`
  query GetMoveLicenseToOrgData($tiers: [String]!) {
    activeMddapOrgsWithOrgUnits {
      Id
      Name
      MddapOrgUnits {
        Id
        Name
        Fei
        IsActive
      }
    }
    getUserRolesByUserTiers(tiers: $tiers) {
      Id
      DisplayName
    }
  }
`;

export default GET_MOVE_LICENSE_TO_ORG_DATA;
